import {REQUEST_CAROUSEL_ITEMS, RECEIVE_CAROUSEL_ITEMS} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function shoppingCartReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_CAROUSEL_ITEMS:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_CAROUSEL_ITEMS:
      return objectAssign({}, state, {
        relatedItems: action.items,
        isFetching: false
      });

    default:
      return state;
  }
}
